import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_campaign_schedule_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  campaign_line_guid: fromDatatype.GuidDataFieldInterface;
  schedule_hdr_guid: fromDatatype.GuidDataFieldInterface;
  schedule_line_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  event_time: fromDatatype.VarcharDatatypeInterface;
  event_date: fromDatatype.VarcharDatatypeInterface;
  start_datetime: fromDatatype.TimestampTzDatatypeInterface;
  end_datetime: fromDatatype.TimestampTzDatatypeInterface;
  repeat_interval: fromDatatype.IntegerDatatypeInterface;
  repeat_on_day: fromDatatype.IntegerDatatypeInterface;
  repeat_count: fromDatatype.IntegerDatatypeInterface;
}

export class bl_dgmkt_campaign_schedule_link_RowClass
  implements bl_dgmkt_campaign_schedule_link_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  campaign_line_guid: fromDatatype.GuidDataFieldInterface;
  schedule_hdr_guid: fromDatatype.GuidDataFieldInterface;
  schedule_line_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  event_time: fromDatatype.VarcharDatatypeInterface;
  event_date: fromDatatype.VarcharDatatypeInterface;
  start_datetime: fromDatatype.TimestampTzDatatypeInterface;
  end_datetime: fromDatatype.TimestampTzDatatypeInterface;
  repeat_interval: fromDatatype.IntegerDatatypeInterface;
  repeat_on_day: fromDatatype.IntegerDatatypeInterface;
  repeat_count: fromDatatype.IntegerDatatypeInterface;
}
